import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Snackbar } from '@mui/material';
import { download } from '@glowforge/builder-components/lib/util/image-helpers';
import { MagicSvgImageShape } from '../../context/MagicSvgContext/MagicSvgProvider';
import MagicSvgIconButton from './magic-svg-icon-button';
import { clientOnly } from '../../util';
import CopyIconMobile from './icons/copy-mobile.svg';
import CopyIconDesktop from './icons/copy-desktop.svg';
import DownloadIconMobile from './icons/download-mobile.svg';
import DownloadIconDesktop from './icons/download-desktop.svg';

const track = (image, type, prefix = '') => {
  const name = prefix ? `magic-svg-${prefix}-${type}` : `magic-svg-${type}`;
  clientOnly(() => {
    if (window.analytics) {
      window.analytics.track(name, {
        name,
        imageId: image.id,
        prompt: image.prompt,
        imageUrl: image.imageUrl,
        svgUrl: image.svgUrl,
        artStyle: image.artStyle,
      });
    }
  });
};

function MagicSvgShare({
  isMobile,
  image,
  hideCopy,
  hideDownload,
  trackPrefix,
}) {
  const [open, setOpen] = useState(false);

  const trackWithPrefix = (type) => track(image, type, trackPrefix);

  const handleDownload = async () => {
    try {
      const fileName = image.prompt || image.additionalFields.userText;
      await download(image.svgUrl, `${fileName.replace(/\s+/g, '-')}.svg`);
      trackWithPrefix('download');
    } catch (e) {
      console.error('Error downloading:', e);
    }
  };

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(window.location.href);
      trackWithPrefix('copy-link');
      setOpen(true);
    } catch (e) {
      console.error('Error copying:', e);
    }
  };

  return (
    <>
      {!hideDownload && (
        <MagicSvgIconButton
          icon={isMobile ? <DownloadIconMobile /> : <DownloadIconDesktop />}
          onClick={handleDownload}
          tooltip='Download'
        />
      )}
      {!hideCopy && (
        <MagicSvgIconButton
          icon={isMobile ? <CopyIconMobile /> : <CopyIconDesktop />}
          onClick={handleCopy}
          tooltip='Copy link'
        />
      )}
      <Snackbar
        open={open}
        autoHideDuration={5000}
        onClose={() => setOpen(false)}
        message='Link copied'
      />
    </>
  );
}

MagicSvgShare.propTypes = {
  isMobile: PropTypes.bool,
  image: PropTypes.shape(MagicSvgImageShape).isRequired,
  trackPrefix: PropTypes.string,
  hideCopy: PropTypes.bool,
  hideDownload: PropTypes.bool,
};

MagicSvgShare.defaultProps = {
  isMobile: false,
  trackPrefix: '',
  hideCopy: false,
  hideDownload: false,
};

export default MagicSvgShare;
